import React from 'react'

import Loading from '../../components/loading'
import BusinessAdminModal from '../../components/Business/BusinessAdminModal'
import BusinessSettingsContent from './settings/BusinessSettingsContent'
import {
  BusinessEditInitialLoading,
  BusinessEditLoadError,
  BusinessEditNoAccount,
} from './settings/BusinessEditStates'
import useBusinessEdit from './settings/useBusinessEdit'

export default function BusinessEdit() {
  const edit = useBusinessEdit()

  if (edit.pageStatus === 'no_business') {
    return <BusinessEditNoAccount />
  }

  if (edit.pageStatus === 'initial_loading') {
    return <BusinessEditInitialLoading />
  }

  if (edit.pageStatus === 'load_error') {
    return <BusinessEditLoadError error={edit.error} onRetry={edit.fetchData} />
  }

  return (
    <>
      <Loading show={edit.businessLoading} />

      <BusinessSettingsContent {...edit} />

      <BusinessAdminModal
        admins={edit.businessAdmins}
        isOpen={edit.isAdminModalOpen}
        onAddAdmin={edit.handleAddAdmin}
        onClose={() => edit.setIsAdminModalOpen(false)}
        onRemoveAdmin={edit.handleRemoveAdmin}
      />
    </>
  )
}
